import { InternalAxiosRequestConfig } from 'axios';

import { API, RELEASE } from '@/config';

import { Header, HttpClient, HttpError, HttpRequestConfig } from './http';

interface ApiCallbackOptions {
  onUnsupportedVersionError?: () => void;
}

export class ApiClient<C extends HttpRequestConfig = HttpRequestConfig> extends HttpClient<C> {
  protected baseOptions?: ApiCallbackOptions;

  constructor(options: C) {
    super(options);

    this.client.interceptors.request.use(this.setHeaders);
    this.client.interceptors.response.use(undefined, this.enforceForceUpdate);
  }

  configureBaseOptions(options: ApiCallbackOptions) {
    this.baseOptions = options;
  }

  private enforceForceUpdate = (error: HttpError<any>) => {
    if (
      error.isAxiosError &&
      error.response?.status === 403 &&
      error.response?.data.code == 'client_version_not_supported'
    ) {
      this.baseOptions?.onUnsupportedVersionError?.();
    }
  };

  private setHeaders = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    config.headers.set(Header.Platform, 'web');
    config.headers.set(Header.Type, 'study');
    config.headers.set(Header.Version, RELEASE);
    return config;
  };
}

export const api = new ApiClient<HttpRequestConfig>({
  baseURL: API,
  headers: { 'Content-Type': 'application/json' }
});
